/**
 * This holds all API routes
 */
const API = {
    PATHS: {
        "LIST": "/api/v1/alert/list",
        "DETAILS": "/api/v1/alert/:alertId",
        "META": "/api/v1/alert/meta"
    }
};
export default API;
